import { Icons } from 'components/icons';
import { AppRoutes } from './routes';

export interface LinkProps {
  path: string;
  label: string;
  icon?: JSX.Element;
  subLinks?: LinkProps[];
}

export const Infopanel = {
  label: 'Infopanel',
  path: AppRoutes.Dashboard.Home + AppRoutes.Dashboard.Infopanel,
};

export const Contracts = {
  icon: <Icons.Contracts />,
  label: 'Contracts',
  path: AppRoutes.Dashboard.Home + AppRoutes.Dashboard.Contracts.Home,
};

export const PowersAttorney = {
  icon: <Icons.PowersAttorney />,
  label: 'Powers of attorney',
  path:
    AppRoutes.Dashboard.Home +
    AppRoutes.Dashboard.PowersAttorney.Home +
    AppRoutes.Dashboard.PowersAttorney.Active,
};

export const Counterparties = {
  icon: <Icons.Counterparties />,
  label: 'Counterparties',
  path:
    AppRoutes.Dashboard.Home +
    AppRoutes.Dashboard.Counterparties.Home +
    AppRoutes.Dashboard.Counterparties.CounterpatyDetail.Home,
};

export const Organizations = {
  icon: <Icons.Organization />,
  label: 'Organizations',
  path:
    AppRoutes.Dashboard.Home +
    AppRoutes.Dashboard.Organizations.Home +
    AppRoutes.Dashboard.Organizations.Requisites,
  subLinks: [
    {
      label: 'Organization profile',
      path:
        AppRoutes.Dashboard.Home +
        AppRoutes.Dashboard.Organizations.Home +
        AppRoutes.Dashboard.Organizations.Requisites,
    },
    {
      label: 'Staffs',
      path:
        AppRoutes.Dashboard.Home +
        AppRoutes.Dashboard.Organizations.Home +
        AppRoutes.Dashboard.Organizations.Staff +
        AppRoutes.Dashboard.Organizations.List,
    },
  ],
};

export const FuelSupply = {
  icon: <Icons.FuelSupply />,
  label: 'Fuel supply',
  path: AppRoutes.Dashboard.Home + AppRoutes.Dashboard.OperationalRequests.Home,
  subLinks: [
    {
      label: 'Operational requests',
      path: AppRoutes.Dashboard.Home + AppRoutes.Dashboard.OperationalRequests.Home,
    },
    {
      label: 'Shipment tasks',
      path: AppRoutes.Dashboard.Home + AppRoutes.Dashboard.ShipmentTasks.Home,
    },
    {
      label: 'Control cards',
      path: AppRoutes.Dashboard.Home + AppRoutes.Dashboard.ControlCards.Home,
    },
    {
      label: 'Shipment reports',
      path: AppRoutes.Dashboard.Home + AppRoutes.Dashboard.ShipmentReports.Home,
    },
    {
      label: 'Shipment registry',
      path: AppRoutes.Dashboard.Home + AppRoutes.Dashboard.ShipmentRegistry.Home,
    },
  ],
};

export const Settings = {
  label: 'Settings',
  path:
    AppRoutes.Dashboard.Home +
    AppRoutes.Dashboard.Settings.Home +
    AppRoutes.Dashboard.Settings.EDOOperator,
  subLinks: [
    {
      label: 'Settings. Common',
      path:
        AppRoutes.Dashboard.Home +
        AppRoutes.Dashboard.Settings.Home +
        AppRoutes.Dashboard.Settings.SettingsCommon,
    },
    {
      label: 'EDO Operation',
      path:
        AppRoutes.Dashboard.Home +
        AppRoutes.Dashboard.Settings.Home +
        AppRoutes.Dashboard.Settings.EDOOperator,
    },
  ],
};

export const linksGeneral: LinkProps[] = [
  Contracts,
  PowersAttorney,
  Counterparties,
  Organizations,
  // Временно не показываем статический раздел поставки топлива.
  // Его маршруты и экраны сохраняются, чтобы не ломать прямые ссылки.
];

export const linksLimitedUser: LinkProps[] = [PowersAttorney];
